import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-linkedin",
  "use": "icon-linkedin-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"icon-linkedin\"><path d=\"M4.281 18H.541V5.982h3.74V18zM2.41 4.343c-1.196 0-2.167-.988-2.167-2.182 0-.573.228-1.123.635-1.528a2.17 2.17 0 013.698 1.528c0 1.194-.97 2.182-2.166 2.182zM18.283 18H14.55v-5.85c0-1.394-.028-3.182-1.945-3.182-1.945 0-2.243 1.514-2.243 3.081V18H6.625V5.982h3.588v1.64h.052c.5-.945 1.72-1.941 3.54-1.941 3.786 0 4.482 2.487 4.482 5.718V18h-.004z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol